export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <path
      d="M32 3 57 12.6v16.6c0 14.6-11 25.5-25 32.4C18 54.7 7 43.8 7 29.2V12.6L32 3Z"
      fill="#16324F"
      stroke="#D9A441"
      strokeWidth="3"
    />
    <path
      d="M17.5 33 32 19.5 46.5 33"
      stroke="#D9A441"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 31.5V47h18V31.5"
      stroke="#FFFFFF"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="28.5" y="36.5" width="7" height="10.5" fill="#D9A441" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => (
  <a
    href="#top"
    data-testid="header-brand-logo"
    className={`flex items-center gap-2.5 ${light ? "text-white" : "text-navy"} ${className}`}
  >
    <LogoMark className="h-10 w-10 shrink-0" />
    <span className="leading-none">
      <span className="block font-display text-[17px] font-semibold tracking-tight">
        Home Defense
      </span>
      <span
        className={`block font-mono text-[9px] font-medium uppercase tracking-[0.26em] ${
          light ? "text-gold-light" : "text-gold-deep"
        }`}
      >
        Solutions LLC
      </span>
    </span>
  </a>
);
